import React from 'react';
import './App.css';
import ControlPanel from './components/ControlPanel';

function App() {
  return (
    <div className="App">
      <div className="container">
        <ControlPanel />
      </div>
    </div>
  );
}

export default App;